module.exports = __webpack_public_path__ + "static/media/bitcoin.6838aa56.png";